export default function otherElectionToggle() {
  // Get all elements with the class "column-end.--large"
  var divTable = document.getElementById("tally-list");
  
  if ( divTable ) {
    const elements = document.querySelectorAll('.column-end.--large');

    elements.forEach(element => { // Add a click event listener to each element
      element.addEventListener('click', () => {
        element.classList.toggle('js-expanded'); // Toggle the "expanded" class on the clicked element

        // Unset the 'default' height explicitly for the box.
        element.style.height = '';
        element.css('min-height', '120px');
      });
    });
  }
}
